import composedLpCta from '../../components-hoc/cta/LpCtaContent'
import BtnRev from './BtnRev'

export default composedLpCta(BtnRev)
